import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
type ReportSectionHeaderProps = {
  title: string;
  rightContent?: ReactNode;
};

/** Tighter than `Card.Header`: a report stacks many sections, so each header's height adds up. */
const ReportSectionHeader = t0 => {
  const $ = _c(7);
  const {
    title,
    rightContent
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <h3 className="min-w-0 break-words text-label-2 text-primary">{title}</h3>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== rightContent) {
    t2 = rightContent && <div className="shrink-0 text-body-2 text-tertiary">{rightContent}</div>;
    $[2] = rightContent;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div data-card-header={true} className="flex min-h-8 items-center justify-between gap-2 px-2 py-1">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default ReportSectionHeader;